import { z } from 'zod'

import { locales } from './data'

const MIN_PURCHASE_PRICE = 100_000

export type LeadFormErrors = typeof locales[string]['errors']

export type LeadFormData = {
  firstName: string
  lastName: string
  phone: string
  email: string
  purchasePrice: string
  contactMethod: string
  hasProperty: boolean
}

export type LeadFormValues = Omit<LeadFormData, 'hasProperty'> & {
  hasProperty: boolean | undefined
}

export const buildLeadFormSchema = (errors: LeadFormErrors) =>
  z.object({
    firstName: z.string().min(1, errors.firstName.required).min(2, errors.firstName.min),
    lastName: z.string().min(1, errors.lastName.required).min(2, errors.lastName.min),
    phone: z
      .string()
      .min(1, errors.phone.required)
      .refine((v) => v.replace(/\D/g, '').length >= 10, errors.phone.invalid),
    email: z.string().min(1, errors.email.required).pipe(z.email(errors.email.invalid)),
    purchasePrice: z
      .string()
      .min(1, errors.purchasePrice.required)
      .regex(/^\d+(\.\d{1,2})?$/, errors.purchasePrice.required)
      .refine((v) => Number(v) >= MIN_PURCHASE_PRICE, errors.purchasePrice.min),
    contactMethod: z.string().min(1, errors.contactMethod.required),
    hasProperty: z.boolean({ message: errors.hasProperty.required }),
  })
